import { render, staticRenderFns } from "./gc-decimal.vue?vue&type=template&id=6d71a5d7&scoped=true&"
import script from "./gc-decimal.vue?vue&type=script&lang=js&"
export * from "./gc-decimal.vue?vue&type=script&lang=js&"
import style0 from "./gc-decimal.vue?vue&type=style&index=0&id=6d71a5d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71a5d7",
  null
  
)

export default component.exports